module.exports = __webpack_public_path__ + "static/img/li1_11.b70b5ca9.png";